import DisplayMode from '../components/DisplayModeSwitch.vue'
import FavoriteButton from '../shared/favorite-button.vue';
import loginmodal from '../shared/login-modal.vue';
import SearchFilter from './filter.vue'
import AdvertiserLocations from '../components/advertiser-locations.vue'

import NoResults from '../shared/no-results.vue'

const app = new Vue({
    el: "#related-search",
    data(){
        return {
            empty: false
        };
    },
    props:{
        propOrderBy: {
            type: Number,
            default: 0
        },
        propIsGridView: {
            type:Boolean,
            default: true
        }
    },
    components: {
        DisplayMode,
        SearchFilter,
        NoResults,
        FavoriteButton,
        loginmodal,
        AdvertiserLocations
    },
    methods: {
        OnChangedViewMode(v) {
            var params = new URLSearchParams(window.location.search);
            params.set("gridview", v.isGrid);
            window.location = this.normalizeUrlParams(params);
        },
        OnChangedSearchViewMode(v){
            this.propIsGridView = v.IsGridView;
        },
        OnChangedSearchOrderBy(v){
            this.propOrderBy = v.OrderBy;
        },
        async OnOrderByChange(v){
            var params = new URLSearchParams(window.location.search);
            params.delete("p");
            params.set("orderBy", v.target.value);            
            window.location = this.normalizeUrlParams(params);
        },
        async onSearchClick(filter){
            if (filter.SearchTerm != null && filter.SearchTerm != ""){                
                var params = new URLSearchParams(window.location.search);
                params.set("search-term", filter.SearchTerm);
                params.delete("p");
                params.delete("s");
                window.location = window.location.pathname + `?${params.toString()}`;
            }else{
                window.location = window.location.pathname;
            }
        },
        async onClearSearchClick(){   
            var params = new URLSearchParams(window.location.search);
            params.delete("search-term");
            params.delete("p");
            params.delete("s");
            window.location = window.location.pathname + `?${params.toString()}`;
        },
        normalizeUrlParams(params){
            if (params == null)
                params = new URLSearchParams(window.location.search);

            if (params.size > 0){
                
                if (params.get("orderBy") == 0){
                    params.delete("orderBy");
                }
                if (params.get("gridview") == 'true'){
                    params.delete("gridview");
                }
                if (params.get("p") == '1'){
                    params.delete("p");
                }
                if (params.get("returnUrl") != null){
                    params.delete("returnUrl");
                }
                
                params.sort();
                if (params.size > 0)
                    return window.location.pathname + `?${params.toString()}`;
            }
            return window.location.pathname;
        }
    },
    mounted(){
        var params = new URLSearchParams(window.location.search);
        if (params.size > 0){
            window.history.replaceState({}, document.title, this.normalizeUrlParams(params));
        }
    }
});
